export const SELLSCREEN_CLASSIFICATION_CHANGE = "SELLSCREEN_CLASSIFICATION_CHANGE";

type Classification = "categories" | "brands" | "families" | "tags";

export interface ChangeClassificationAction {
    type: typeof SELLSCREEN_CLASSIFICATION_CHANGE;
    classification: Classification;
    uuid: string;
    isCase: boolean;
}

export interface ClassificationState {
    type: Classification | null;
    uuid: string | null;
    isCase: boolean;
}

export function changeClassification(type: Classification, uuid: string, isCase = false): ChangeClassificationAction {
    return {
        type          : SELLSCREEN_CLASSIFICATION_CHANGE,
        classification: type,
        uuid          : uuid,
        isCase        : isCase,
    };
}
